import { useEffect } from "react";
import { changedSinceClosing, editsMasterData, inventoryReport, noteChanges } from "@lagerlog/core";
import { catalogOf } from "./catalog.ts";
import { useStore } from "./hooks.ts";

const DAY = 86_400_000;

/**
 * Watches closed inventories: when a late booking changes a frozen report, the change is noted on
 * the inventory with the time it was noticed (docs/04-domaenenmodell.md: "Hinweis und
 * Logbucheintrag"). Runs a little after the data settle, on any screen.
 */
export function useInventoryWatch() {
  const { store, version } = useStore();
  useEffect(() => {
    const timer = setTimeout(() => {
      const replica = store.replica;
      // Noting it changes master data: owners and managers only (F20).
      if (!replica || !editsMasterData(store.rights().role)) return;
      const catalog = catalogOf(replica);
      const state = replica.state();
      for (const inv of catalog.inventories.values()) {
        if (inv.status !== "closed" || !inv.report || (inv.closedAt ?? 0) < Date.now() - 90 * DAY) continue;
        const now = inventoryReport(state, replica.journal(), inv, Date.now());
        const changes = noteChanges(inv.changes ?? [], changedSinceClosing(inv.report, now), Date.now());
        if (changes) void store.edit("inventory", inv.id, { changes });
      }
    }, 2000);
    return () => clearTimeout(timer);
  }, [version]); // eslint-disable-line react-hooks/exhaustive-deps
}
